export const toBase64 = (file: File) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });

/**
 * Converts a base64 string to a File object.
 *
 * @param base64 - The base64 string to convert.
 * @param fileName - The name of the file to create.
 * @param mimeType - The MIME type of the file.
 * @returns The File object created from the base64 string.
 */
export const base64ToFile = (base64: string, fileName: string, mimeType: string): File => {
  const byteString = atob(base64.split(',')[1]);
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);

  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new File([ab], fileName, { type: mimeType });
};

export const base64ToImageUrl = (data: string, fileName: string, mimeType: string) =>
  URL.createObjectURL(base64ToFile(data, fileName, mimeType));

export const base64ToMimeType = (data: string) => {
  if (data.includes('jpeg') || data.includes('jpg')) {
    return 'image/jpg';
  }
  if (data.includes('png')) {
    return 'image/png';
  }
  if (data.includes('svg') || data.includes('SVG')) {
    return 'image/svg+xml';
  }
  return 'file';
};

export const getBase64 = (file: any) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

export const getFileExtension = (url: string): string | null => {
  const parts = url.split('.');
  if (parts.length > 1) {
    return parts.pop() || null;
  }
  const isBase64String = url.includes('base64');
  const isSvg = url.includes('image/svg');

  if (isBase64String && isSvg) {
    return url.includes('svg') || url.includes('SVG') ? 'svg' : null;
  }

  return null;
};
